import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../utils/Customer/apiBaseQuery";
import {
  CALCULATE_PETTAXI_PRICE,
  CANCEL_BOOKING,
  CUSTOMER_REWARD,
  FREE_PACKAGE_BOOKINGS,
  FREE_PACKAGE_RESCHEDULE_SLOTS,
  GET_AVAIALBALE_SLOTS,
  GET_AVAILABLE_SLOTS,
  GET_BOOKING_BY_ID,
  GET_CHECKOUT_SUMMARY,
  GET_FILTERED_PACKAGES,
  GET_MY_BOOKINGS,
  GET_OFFER_CALENDAR,
  GET_OFFERS_CALENDAR,
  GET_PACKAGE_ADD_ONS,
  GET_PACKAGES,
  GET_PET_DETAILS,
  GET_PRODUCT_DETAILS,
  GET_WORKING_DAY,
  GET_WORKING_DAYS_BY_SERVICEID,
  MY_PACKAGES,
  RESCHEDULE_BOOKING,
  RESCHEDULE_SLOTS,
  SEARCH_FILTERS,
  SEARCH_PETS,
  SEARCH_PETS_FILTERS,
  SEARCH_PRODUCTS,
  SEARCH_SUGGESTIONS,
  UPCOMING_BOOKING,
} from "../../../config/apiUrlsCustomer";
import {
  BookingSlot,
  GetAddOnsResponse,
  IAvailableSlotsResponse,
  ICalculatePettaxiPriceResponse,
  ICheckoutSummaryResponse,
  IFilteredPackagesResponse,
  IFilterResponse,
  IGetBookingDetailsById,
  IGetOffersCalendarResponse,
  IGetWorkingDaysByIdResponse,
  IMultiPackageUsedresponse,
  IMyBookingsResponse,
  IPetSearchResponse,
  IRewardPointsResponse,
  IVideosResponse,
  PetDetails,
  ProductDetailsResponse,
} from "../../../types/Response/CustomerResponse";
import {
  IAvailableSlotssRequest,
  ICancelBookingsRequest,
  ICreateFreeBookingsRequest,
  IFilteredPackagesRequest,
  IGetFreePackageRescheduleSlotsRequest,
  IGetMyBookingsRequest,
  IGetOffersCalendarRequest,
  IGetRescheduleSlotsRequest,
  IPaginatedResult,
  IPetSearchRequest,
  IPetTaxiPriceCalculateRequest,
  IProductCard,
  IRescheduleBookingRequest,
  ISearchFiltersResponse,
  ISearchProductsRequest,
  ISearchSuggestionRequest,
  ISearchSuggestionResponse,
  IVideosRequest,
} from "../../../types/Request/CustomerRequest";
import { GET_ADD_ONS } from "../../../config/apiUrlsAdmin";

export const serviceCustomerAPi = createApi({
  reducerPath: "serviceCustomerAPi",
  baseQuery: axiosBaseQuery(),

  endpoints: (builder) => ({
    getFilteredPackages: builder.mutation<
      IFilteredPackagesResponse,
      IFilteredPackagesRequest
    >({
      query: (data) => ({
        url: `${GET_PACKAGES}`,
        method: "post",
        data: data,
      }),
    }),
    getWorkingDaysByServiceId: builder.query<
      IGetWorkingDaysByIdResponse,
      string
    >({
      query: (serviceId) => ({
        url: `${GET_WORKING_DAY}/${serviceId}`,
        method: "get",
      }),
    }),
    getOffersCalendar: builder.mutation<
      IGetOffersCalendarResponse,
      IGetOffersCalendarRequest
    >({
      query: (data) => ({
        url: `${GET_OFFER_CALENDAR}`,
        method: "post",
        data: data,
      }),
    }),
    getAvailableSlots: builder.mutation<
      IAvailableSlotsResponse,
      IAvailableSlotssRequest
    >({
      query: (data) => ({
        url: `${GET_AVAILABLE_SLOTS}`,
        method: "post",
        data: data,
      }),
    }),

    getAddOns: builder.query<GetAddOnsResponse, number>({
      query: (serviceId) => ({
        url: `${GET_PACKAGE_ADD_ONS}/${serviceId}`,
        method: "get",
      }),
    }),

    /////////  PRODUCT CUSTOMER /////
    getProductDetails: builder.query<ProductDetailsResponse, Number>({
      query: (id) => ({
        url: `${GET_PRODUCT_DETAILS}/${id}`,
        method: "get",
      }),
    }),
        getVideos: builder.query<IVideosResponse, IVideosRequest>({
      query: (data) => ({
        url: `${GET_PRODUCT_DETAILS}/videos`,
        method: "get",
        data:data
      }),
    }),

    getSearchSuggestions: builder.query<
      ISearchSuggestionResponse,
      ISearchSuggestionRequest
    >({
      query: ({ query, productTake, brandTake, categoryTake,petTake }) => ({
        url:
          `${SEARCH_SUGGESTIONS}` +
          `?query=${encodeURIComponent(query)}` +
          `&productTake=${productTake}` +
          `&brandTake=${brandTake}` +
          `&categoryTake=${categoryTake}` +
          `&petTake=${petTake}`,
        method: "get",
      }),
    }),

    getSearchFilters: builder.mutation<
      ISearchFiltersResponse,
      ISearchProductsRequest
    >({
      query: (data) => ({
        url: SEARCH_FILTERS,
        method: "post",
        data,
      }),
    }),

    searchProducts: builder.mutation<
      IPaginatedResult<IProductCard>,
      ISearchProductsRequest
    >({
      query: (data) => ({
        url: SEARCH_PRODUCTS,
        method: "post",
        data,
      }),
    }),

    /////////  PET CUSTOMER /////

    getPetDetails: builder.query<PetDetails, Number>({
      query: (id) => ({
        url: `${GET_PET_DETAILS}/${id}`,
        method: "get",
      }),
    }),

    
    getPetFilters: builder.query<IFilterResponse, void>({
      query: (id) => ({
        url: SEARCH_PETS_FILTERS,
        method: "get",
      }),
    }),

        petListingOrSearch: builder.mutation<
      IPetSearchResponse,
      IPetSearchRequest
    >({
      query: (data) => ({
        url: SEARCH_PETS,
        method: "post",
        data,
      }),
    }),

    ////  GET SUMM ///
    getCheckoutSummary: builder.query<ICheckoutSummaryResponse, void>({
      query: () => ({
        url: GET_CHECKOUT_SUMMARY,
        method: "get",
      }),
    }),



    ////   myy bookings ///

    getMyBookings: builder.query<IMyBookingsResponse[], IGetMyBookingsRequest>({
      query: (data) => ({
        url: GET_MY_BOOKINGS,
        method: "post",
        data: data, // <--- Sent as raw JSON Request Body matching Swagger
      }),
    }),

    getBookingDetailsById: builder.query<IGetBookingDetailsById, number>({
      query: (bookingId) => ({
        url: `${GET_BOOKING_BY_ID}/${bookingId}`,
        method: "get",
      }),
    }),


    getUpComingBookings: builder.query<ICheckoutSummaryResponse, void>({
      query: () => ({
        url: UPCOMING_BOOKING,
        method: "get",
      }),
    }),


    cancelBookings: builder.mutation<boolean, ICancelBookingsRequest>({
      query: (data) => ({
        url: CANCEL_BOOKING,
        method: "put",
        data: data
      }),
    }),
    rescheduleBooking: builder.mutation<boolean, IRescheduleBookingRequest>({
      query: (data) => ({
        url: RESCHEDULE_BOOKING,
        method: "put",
        data: data
      }),
    }),
    rescheduleSlots: builder.mutation<BookingSlot[], IGetRescheduleSlotsRequest>({
      query: (data) => ({
        url: RESCHEDULE_SLOTS,
        method: "post",
        data: data
      }),
    }),
       freePackageRescheduleSlots: builder.mutation<BookingSlot[], IGetFreePackageRescheduleSlotsRequest>({
      query: (data) => ({
        url: FREE_PACKAGE_RESCHEDULE_SLOTS,
        method: "post",
        data: data
      }),
    }),

    getMyPackages: builder.query<IMultiPackageUsedresponse[], void>({
      query: () => ({
        url: MY_PACKAGES,
        method: "get",
      }),
    }),

       freePackageBooking: builder.mutation<boolean, ICreateFreeBookingsRequest>({
      query: (data) => ({
        url: FREE_PACKAGE_BOOKINGS,
        method: "post",
        data: data
      }),
    }),

           calculatePetTaxiPrice: builder.mutation<ICalculatePettaxiPriceResponse, IPetTaxiPriceCalculateRequest>({
      query: (data) => ({
        url: CALCULATE_PETTAXI_PRICE,
        method: "post",
        data: data
      }),
    }),

    
    getRewardDashboard: builder.query<IRewardPointsResponse, void>({
      query: () => ({
        url: CUSTOMER_REWARD,
        method: "get",
      }),
    }),


  }),
});

export const {
  useGetFilteredPackagesMutation,
  useGetWorkingDaysByServiceIdQuery,
  useGetOffersCalendarMutation,
  useGetAvailableSlotsMutation,
  useLazyGetPetDetailsQuery,

  useLazyGetProductDetailsQuery,
  useLazyGetAddOnsQuery,
  useLazyGetSearchSuggestionsQuery,

  useGetSearchSuggestionsQuery,

  useSearchProductsMutation,

  useGetSearchFiltersMutation,



  useLazyGetBookingDetailsByIdQuery,
  useLazyGetMyBookingsQuery,
  useLazyGetUpComingBookingsQuery,
  useCancelBookingsMutation,
  useRescheduleBookingMutation,
  useRescheduleSlotsMutation,
  useFreePackageRescheduleSlotsMutation,

  useLazyGetMyPackagesQuery,
  useFreePackageBookingMutation,

  useCalculatePetTaxiPriceMutation,

  useLazyGetPetFiltersQuery,
  usePetListingOrSearchMutation,
  useLazyGetRewardDashboardQuery,
  useLazyGetVideosQuery
} = serviceCustomerAPi;
